var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import CreateOrEditGoalPlannerTemplateDialog from '@/views/GoalPlanner/CreateOrEditGoalPlannerTemplateDialog/CreateOrEditGoalPlannerTemplateDialog.vue';
import ErrorHandler from '@/support/ErrorHandler';
import { GoalPlannerTemplate } from '@/models/GoalPlannerTemplate';
let Templates = class Templates extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Templates';
        // #region @VModel
        // #endregion
        // #region @PropSyncs
        // #endregion
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isCreatingOrEditingTemplate = false;
        this.selectedTemplate = null;
        this.filterTemplateTypeItems = [
            {
                label: this.$tc('Day'),
                value: 'day',
            },
            {
                label: this.$tc('Week'),
                value: 'week',
            },
        ];
        this.filters = {
            type: '',
        };
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    onClickCreate() {
        this.isCreatingOrEditingTemplate = true;
    }
    onCloseCreateOrEditDialog() {
        this.isCreatingOrEditingTemplate = false;
        this.selectedTemplate = null;
    }
    // #endregion
    // #region Class methods
    refreshDataTable() {
        this.isCreatingOrEditingTemplate = false;
        this.refreshFilterStore();
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    getTypeLabel(type) {
        switch (type) {
            case 'day':
                return this.$tc('Day');
            case 'week':
                return this.$tc('Week');
            default:
                return type;
        }
    }
    getFormattedCreatedAt(createdAt) {
        return createdAt.replace('T', ' ').substring(0, 16);
    }
    // #endregion
    // #region Async methods (api calls only)
    async handleDuplicate(goalPlannerTemplate) {
        try {
            await goalPlannerTemplate.duplicate(goalPlannerTemplate.id);
            this.refreshDataTable();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async refreshFilterStore() {
        await new GoalPlannerTemplate()
            .all()
            .then((goalPlannerTemplates) => {
            const mutatedGoalPlannerTemplates = [];
            const payload = {};
            goalPlannerTemplates.forEach((goalPlannerTemplate) => {
                mutatedGoalPlannerTemplates.push({
                    value: goalPlannerTemplate.id,
                    text: goalPlannerTemplate.getFilterLabel(),
                });
            });
            payload.GoalPlannerTemplate = mutatedGoalPlannerTemplates;
            this.$store.dispatch('updateFilters', payload);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    // #endregion
    // #region Getters & Setters
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('Period planner template', 1),
                plural: this.$tc('Period planner templates', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'title',
                    editable: false,
                    changed: false,
                    action: '/goal-planner/templates/{id}',
                },
                {
                    text: this.$t('Type'),
                    value: 'type',
                    slot: 'type',
                    editable: false,
                    changed: false,
                },
                {
                    text: this.$t('Created by'),
                    value: 'created_by',
                    slot: 'created_by',
                    editable: false,
                    changed: false,
                },
                {
                    text: this.$t('Created at'),
                    value: 'created_at',
                    slot: 'created_at',
                    editable: false,
                    changed: false,
                },
            ],
            actions: [
                {
                    type: 'view',
                    label: 'view',
                    icon: 'remove_red_eye',
                    visible: (vm, template) => {
                        return true;
                    },
                    action: (vm, template) => {
                        if (!template || !template.id) {
                            return;
                        }
                        this.$router.push({ name: 'goal-planner.template.index', params: { id: template.id } });
                    },
                },
                {
                    type: 'copy',
                    label: 'copy',
                    icon: 'content_copy',
                    visible: true,
                    action: (vm, template) => {
                        if (!template || !template.id) {
                            return;
                        }
                        this.handleDuplicate(template);
                    },
                },
                {
                    type: 'edit',
                    label: 'edit',
                    icon: 'edit',
                    visible: (vm, template) => {
                        return this.user.id === template.user_id;
                    },
                    action: (vm, template) => {
                        if (!template || !template.id) {
                            return;
                        }
                        this.selectedTemplate = template;
                        this.isCreatingOrEditingTemplate = true;
                    },
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    visible: (vm, template) => {
                        return this.user.id === template.user_id;
                    },
                    action: (vm, template) => {
                        this.selectedTemplate = template;
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ],
            filters: [],
            model: new GoalPlannerTemplate().include('user').filter(this.filters),
        };
    }
    get dialogOptions() {
        const template = this.selectedTemplate;
        return {
            title: this.$tc('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: template.title }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!template) {
                            return;
                        }
                        template
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedTemplate = null;
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedTemplate = null;
                    },
                },
            },
        };
    }
    get user() {
        return this.$store.state.Auth;
    }
    get title() {
        return this.$tc('Period planner templates');
    }
};
Templates = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            CreateOrEditGoalPlannerTemplateDialog,
        },
    })
], Templates);
export default Templates;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
